export const DEFAULT_GRID_BACKGROUND = {
    fill: "#bbb",
    fillOpacity: .2
};
//# sourceMappingURL=config.js.map
